export class Stampimage {
  id: number;
  name: string;
  length: string;
  positionX: number;
  positionY: number;
  percentSize: number;
  rotation: number;
  contentPosition: number;
  pageStamp: number;
  stampOn: number;
  base64Data: string;
  active: number;
}
